import React from 'react';
import { SkeletonItem } from 'components/Dashboard/KeyUpdates/SkeletonKeyUpdates';
import { SkeletonConsultationItem } from 'components/Dashboard/ConsultationsSection/SkeletonConsultation';
import { SkeletonLegislationItem } from 'components/Dashboard/Legislation/SkeletonLegislation';
import { SkeletonParliamentaryItem } from 'components/Dashboard/ParliamentaryRecord/SkeletonParliamentary';
import { SkeletonInfluenceSingleItem } from 'components/Dashboard/Influence/skeletons/SkeletonInfluenceList';
import SkeletonItemTwitter from 'components/Dashboard/SocialMedia/SkeletonItemTwitter';

const ListItemSkeleton = ({ sectionName }) => {
  switch (sectionName) {
    case 'KeyUpdates':
      return <SkeletonItem />;
    case 'Consultations':
      return <SkeletonConsultationItem />;
    case 'Legislation':
      return <SkeletonLegislationItem />;
    case 'ParliamentaryRecord':
    case 'CommitteePublication':
      return <SkeletonParliamentaryItem />;
    case 'Influence':
      return <SkeletonInfluenceSingleItem />;
    case 'SocialMedia':
      return <SkeletonItemTwitter />;
    default:
      return <SkeletonItem />;
  }
};

export default ListItemSkeleton;
